module.exports = __webpack_public_path__ + "img/luach_yes.a8c7a3bf.png";